import { action, makeObservable, observable } from 'mobx';
import { IFieldInfo } from '../interfaces/IFieldInfo';

export class ContextStore {
  constructor() {
    makeObservable(this);
  }

  @observable activeField: IFieldInfo | undefined;

  @observable isLoggedIn = false;

  @observable isConnectedPtu = false;

  @action setActiveField = (activeField: IFieldInfo | undefined): void => {
    this.activeField = activeField;
  };

  @action setLoggedIn = (loggedInUser?: any): void => {
    this.isLoggedIn = !!loggedInUser;
  };

  @action setIsConnectedPtu = (isConnectedPtu?: any): void => {
    this.isConnectedPtu = !!isConnectedPtu;
  };

  ensureActiveFieldPresent(): void {
    if (!this.activeField?.systemId) {
      throw new Error('Tracking unit must be connected to perform this action');
    }
  }
}
